import React from 'react';

import { i18n } from '../../i18n';

import SectionHeader from '../../section-header';
import Paras         from '../../paras';
import ModalImage    from '../../modal-image';

import * as css   from './index.module.css';
import Screenshot from '../../screenshot';

const prefix = 'part3.ac';

export default function AdvancedCombat() {
    return <>
        <SectionHeader name="advanced-combat" />

        <div className={css.sec0}>
            <h3>{i18n(`${prefix}.enw.header`)}</h3>

            <div className={css.cols}>
                <div className={css.col}>
                    <Paras path={`${prefix}.enw.para`} end={1} doReplace={true} />
                </div>

                <p className={css.col1}>{i18n(`${prefix}.enw.para.2`)}</p>
            </div>
        </div>

        <div className={css.fullWidth}>
            <div>
                <h3 className={css.sec1Header}>{i18n(`${prefix}.fsra.header`)}</h3>
                <div className={css.sec1}>
                    <div className={css.col}>
                        <Paras path={`${prefix}.fsra.para`} />
                    </div>

                    <ModalImage path={`${prefix}.fsra.modal`} className={css.screenshot}>
                        <Screenshot path={`${prefix}.fsra.img`} />
                    </ModalImage>
                </div>
            </div>
        </div>
    </>;
}

